import { create } from 'zustand';

export const useSessionStore = create((set) => ({
  user: {},
  credentials: null, // {accessToken: '', expiration: 0},
  partners: [],
  menuCollapsed: false,

  setUser: (user) => {
    set((state) => ({...state, user}));
  },
  setUserAndCredential: (user , credentials) => {
    set((state) => ({...state, user, credentials}));
  },
  setCredentials: (credentials) => {
    set((state) => ({...state, credentials}));
  },
  clearCredentials: () => {
    set((state) => ({...state, credentials: null}));
  },
  setPartners: (partners) => {
    set((state) => ({...state, partners}));
  },
  addPartner: (partner) => {
    set((state) => ({...state, partners: [...state.partners, partner]}));
  },
  removePartner: (partner) => {
    set((state) => ({...state, partners: [...state.partners.filter((item) => {
        return item !== partner
      })]}));
  },
  setMenuCollapsed: (collapsed) => {
    set((state) => ({...state, menuCollapsed: !collapsed}));
  },
}));
